import React from 'react';
import styled from 'styled-components';

function SvgIcon(props) {
const EditedLogo = styled.div`
svg {
    width: ${props.width};
    fill: ${props.fill};
}
    `;
    return <EditedLogo>
        {props.icon}
    </EditedLogo>
}

export default SvgIcon;